export default __webpack_public_path__ + "static/media/project_metananos.77582750.png";